import { render } from "./Physiotherapy.vue?vue&type=template&id=61e3011d"
import script from "./Physiotherapy.vue?vue&type=script&lang=js"
export * from "./Physiotherapy.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./Physiotherapy.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "C:\\Users\\antho\\Documents\\Projects\\ynforma-website\\ynforma-website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__